module.exports = __webpack_public_path__ + "media/StudentAdvice_Britney.076cefd1.mp4";